import { SvgIcon } from "@mui/material";
import { ReactComponent as AcademicIcon } from "./../Icons/Academic.svg";
import { ReactComponent as UploadIcon } from "./../Icons/Upload.svg";
import { ReactComponent as BasicsIcon } from "./../Icons/Basics.svg";
import { ReactComponent as ResearchIcon } from "./../Icons/Research.svg";
import { ReactComponent as PreviousEmploymentIcon } from "./../Icons/PreviousEmployment.svg";
import { ReactComponent as ParallelIcon } from "./../Icons/Parallel.svg";
import { ReactComponent as ApplicationIcon } from "./../Icons/Application.svg";
import { ReactComponent as SalariesIcon } from "./../Icons/Salaries.svg";
import { ReactComponent as EquipmentIcon } from "./../Icons/Equipment.svg";
import { ReactComponent as TravelIcon } from "./../Icons/Travel.svg";
import { ReactComponent as OperatingIcon } from "./../Icons/Operating.svg";
import { ReactComponent as SuppliesAndMaterialsIcon } from "./../Icons/SuppliesAndMaterials.svg";
import { ReactComponent as OtherIcon } from "./../Icons/Other.svg";
import { ReactComponent as OverviewIcon } from "./../Icons/Overview.svg";
import { ReactComponent as SuggestedReviewersIcon } from "./../Icons/SuggestedReviewers.svg"
import { ReactComponent as NoSendReviewersIcon } from "./../Icons/NoSendReviewers.svg";
import { ReactComponent as BioethicalApprovalsIcon } from "./../Icons/BioethicalApprovals.svg";
import { ReactComponent as ProjectSchedulesIcon } from "./../Icons/ProjectSchedules.svg";
import { ReactComponent as RestoreIcon } from "./../Icons/Restore.svg";
import { ReactComponent as SubmitIcon } from "./../Icons/Submit.svg";
import { ReactComponent as WarningIcon } from "./../Icons/Warning.svg";

export const Academic = (props) => (
  <SvgIcon {...props} component={AcademicIcon} viewBox="0 0 19 13" />
);
export const Upload = (props) => (
  <SvgIcon {...props} component={UploadIcon} viewBox="0 0 15 15" />
);
export const Basics = (props) => (
  <SvgIcon {...props} component={BasicsIcon} viewBox="0 0 18 18" />
);
export const Research = (props) => (
  <SvgIcon {...props} component={ResearchIcon} viewBox="0 0 14 14" />
);
export const PreviousEmployment = (props) => (
  <SvgIcon {...props} component={PreviousEmploymentIcon} viewBox="0 0 14 14" />
);
export const Parallel = (props) => (
  <SvgIcon {...props} component={ParallelIcon} viewBox="0 0 17 17" />
);
export const Edit = (props) => (
  <SvgIcon {...props} component={ApplicationIcon} viewBox="0 0 17 17" />
);
export const Salaries = (props) => (
  <SvgIcon {...props} component={SalariesIcon} viewBox="0 0 17 17" />
);
export const Equipment = (props) => (
  <SvgIcon {...props} component={EquipmentIcon} viewBox="0 0 17 17" />
);
export const Travel = (props) => (
  <SvgIcon {...props} component={TravelIcon} viewBox="0 0 17 17" />
);
export const Operating = (props) => (
  <SvgIcon {...props} component={OperatingIcon} viewBox="0 0 17 17" />
);
export const SuppliesAndMaterials = (props) => (
  <SvgIcon {...props} component={SuppliesAndMaterialsIcon} viewBox="0 0 17 17" />
);
export const Other = (props) => (
  <SvgIcon {...props} component={OtherIcon} viewBox="0 0 17 17" />
);
export const Overview = (props) => (
  <SvgIcon {...props} component={OverviewIcon} viewBox="0 0 17 17" />
);
export const SuggestedReviewers = (props) => (
  <SvgIcon {...props} component={SuggestedReviewersIcon} viewBox="0 0 17 17" />
);
export const NoSendReviewers = (props) => (
  <SvgIcon {...props} component={NoSendReviewersIcon} viewBox="0 0 17 17" />
);
export const BioethicalApprovals = (props) => (
  <SvgIcon {...props} component={BioethicalApprovalsIcon} viewBox="0 0 17 17" />
);
export const ProjectSchedules = (props) => (
  <SvgIcon {...props} component={ProjectSchedulesIcon} viewBox="0 0 17 17" />
);
export const Restore = (props) => (
  <SvgIcon {...props} component={RestoreIcon} viewBox="0 0 17 17" />
);
export const Submit = (props) => (
  <SvgIcon {...props} component={SubmitIcon} viewBox="0 0 17 17" />
);
export const Warning = (props) => (
  <SvgIcon {...props} component={WarningIcon} viewBox="0 0 21 21" />
);

